import { useRouter } from 'next/router';
import Script from 'next/script';
import { useEffect, useState } from 'react';
import { grantFBConsent } from '@/utils/analytics/facebook/grantFBConsent';

// Extend Window interface to include fbq
declare global {
  interface Window {
    fbq: (action: string, eventName: string, parameters?: object, options?: {
      eventID?: string;
    }) => void;
  }
}
const FB_PIXEL_ID = process.env.NEXT_PUBLIC_FB_PIXEL_ID;
export const FacebookPixel = () => {
  const [loaded, setLoaded] = useState(false);
  const router = useRouter();
  useEffect(() => {
    if (!loaded) {
      return;
    }
    grantFBConsent();
  }, [loaded]);
  useEffect(() => {
    // Only track PageView if the script has loaded and fbq is available
    if (!loaded || typeof window === 'undefined' || !window.fbq) {
      return;
    }
    window.fbq('track', 'PageView');
  }, [router.asPath, loaded]);

  // Don't render the script if we don't have a pixel ID
  if (!FB_PIXEL_ID) {
    console.warn('Facebook Pixel ID is not configured');
    return null;
  }
  return <Script dangerouslySetInnerHTML={{
    __html: `!function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${FB_PIXEL_ID}');`
  }} data-pixel-id={FB_PIXEL_ID} id="fb-pixel" onError={e => {
    console.error('Facebook Pixel script failed to load:', e);
  }} onReady={() => setLoaded(true)} strategy="afterInteractive" data-sentry-element="Script" data-sentry-component="FacebookPixel" data-sentry-source-file="FacebookPixel.tsx" />;
};